import store from '@/store';

import sitePaths from './site_paths';
import adminPaths from './admin_paths';

export default [
  {
    path: '*',
    view: 'NotFound',
    title: 'Not Found',
    layout: 'centered',
  },
  {
    path: '/login',
    name: 'Login',
    view: 'Login',
    title: 'Login',
    layout: 'centered',
  },
  {
    path: '/me',
    view: 'UserProfile',
    title: 'My Profile',
  },
  {
    path: '/sites/:site_id',
    view: 'EmptyRouterView',
    name: 'SiteView',
    meta: {
      isAdmin: false,
    },
    children: sitePaths,
    beforeEnter: (to, from, next) => {
      const siteId = to.params.site_id;
      if (siteId !== store.getters['app/activeSite']) {
        store.commit('app/setActiveSite', siteId);
      }
      return next();
    },
  },
  {
    path: '/admin',
    view: 'EmptyRouterView',
    name: 'AdminView',
    children: adminPaths,
    meta: {
      isAdmin: true,
    },
  },
];
